import type { Practitioner, Reference } from '@medplum/fhirtypes'
import type { ExtendedPractitioner } from '@seen/core/models/practitioner'

// A label containing only a resource reference is not a person's name.
const RAW_REFERENCE_LABEL = /^[A-Za-z]+\/[0-9a-f-]{8,}$/i

const SHORT_ID_LENGTH = 7

function shortId(reference: string | undefined): string {
  const id = reference?.split('/').pop()?.replace(/-/g, '') ?? ''
  return id.slice(0, SHORT_ID_LENGTH)
}

export function ownerFilterLabel(
  owner: Reference<Practitioner>,
  practitioner: ExtendedPractitioner | undefined
): string {
  const recordName =
    practitioner && practitioner.name !== 'Unknown'
      ? practitioner.name
      : undefined
  const referenceName =
    owner.display && !RAW_REFERENCE_LABEL.test(owner.display)
      ? owner.display
      : undefined
  const name = recordName ?? referenceName ?? shortId(owner.reference)
  return practitioner?.active === false ? `${name} (deactivated)` : name
}
